import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import styles from './testOverview.scss';
import timeUtils from '../../qti/utils/TimeUtils';
import { t } from '../../services/i18nService';
import reloginService from '../../services/ReloginService';

const LoadProgressBarContent = React.memo(({ cacheStatus, caption, id, isOnline }) => {
    let percentLoaded = cacheStatus?.loadProgress?.percentageLoaded || 0;
    const secondsToDisplay = cacheStatus?.loadProgress?.estimatedTimeLeft || 0;
    const hasFailed = cacheStatus?.loadProgress?.hasFailed || !isOnline;
    let moreLoadInfo = null;
    if (hasFailed) {
        moreLoadInfo = t('childTest.loadingDownloadInterrupted');
        percentLoaded = 0;
    } else if (!isFinite(secondsToDisplay)) {
        moreLoadInfo = t('childTest.loadingCalculatingTime');
    } else if (secondsToDisplay > 0) {
        moreLoadInfo = t('childTest.loadingEstimatedTimeLeft', { time: timeUtils.formatDuration(secondsToDisplay * 1000, t, false) });
    }

    if (!hasFailed && reloginService.isResumedTestWithReloginRules()) {
        const extraInfo = moreLoadInfo;
        moreLoadInfo = (<div id="autoEnterWarning">
            <p>{extraInfo}</p>
            <p>{t('childTest.childTestWillAutoEnterWarning')}</p>
        </div>);
    }

    const progressBarId = `progressBar_${id}`;

    return (
        <div className={`${styles.actionBox} ${styles.current} ${styles.loadProgress}`}>
            <div>
                {caption}
                <div className={styles.progressBarWithLabel}>
                    <div className={styles.progressBarWrapper}>
                        <progress id={progressBarId} className={styles.progressBar} max="100" value={percentLoaded} />
                    </div>
                    <label htmlFor={progressBarId} className={styles.progressPercentage}>
                        {percentLoaded}%
                    </label>
                </div>
                {moreLoadInfo}
            </div>
        </div>
    );
});

LoadProgressBarContent.propTypes = {
    cacheStatus: PropTypes.object,
    caption: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
    return { isOnline: state.api.isOnline };
}

const LoadProgressBar = connect(mapStateToProps)(LoadProgressBarContent);

export default LoadProgressBar;
